/**
 * @generated SignedSource<<eef9255ce26f4dd67d0b3a3531de2a30>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type eventInlineFragment$data = {
  readonly id: string;
  readonly name: string;
  readonly userId: string;
  readonly accountId: string;
  readonly description: string | null;
  readonly location: string | null;
  readonly beginsAt: any;
  readonly endsAt: any;
  readonly recurring: boolean;
  readonly timeZone: string;
  readonly type: string;
  readonly source: string;
  readonly createdBy: string | null;
  readonly comment: string | null;
  readonly status: string;
  readonly icalendar: string | null;
  readonly recurrenceID: string | null;
  readonly originalStartTime: string | null;
  readonly createdAt: any | null;
  readonly eventGuests: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"eventGuestInlineFragment">;
  }>;
  readonly userProfile: {
    readonly " $fragmentSpreads": FragmentRefs<"userProfileBaseFragment" | "userProfileNameFragment" | "userProfileBaseInlineFragment" | "userProfileNameInlineFragment">;
  };
  readonly createdByUserProfile: {
    readonly " $fragmentSpreads": FragmentRefs<"userProfileNameInlineFragment">;
  } | null;
  readonly zoomMeetingDetails: any | null;
  readonly sessionType: string | null;
  readonly googleMeetDetails: any | null;
  readonly completedDatetime: any | null;
  readonly cancellationReasonType: string | null;
  readonly practitionerConfirmationDatetime: any | null;
  readonly " $fragmentType": "eventInlineFragment";
};
export type eventInlineFragment$key = {
  readonly " $data"?: eventInlineFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"eventInlineFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "eventInlineFragment"
};

(node as any).hash = "ee9c18fe17e7ff3264bb8f7a23770360";

export default node;
